<template>
  <main>
    <v-card v-if="loaded" style="border-radius: 10px">
      <v-card-title style="font-size: 1rem">
        {{ $t("location_title") }}
      </v-card-title>
      <v-card-text>
        <BarChart :chartData="chartData" :options="options" />
      </v-card-text>
    </v-card>
    <v-col v-else cols="12" class="text-center">
      <v-progress-circular
        size="100"
        class="text-center"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-col>
  </main>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";

export default {
  name: "ReservationStatistics",
  components: {
    BarChart: () => import("@/components/BarChart")
  },
  data() {
    return {
      loaded: false,
      chartData: {
        labels: [],
        datasets: [{ backgroundColor: "", data: [] }]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            align: "end",
            anchor: "end",
            color: function(context) {
              return context.dataset.backgroundColor;
            },
            font: function(context) {
              var w = context.chart.width;
              return {
                size: w < 512 ? 16 : 18,
                weight: "bold"
              };
            }
            // formatter: function (value, context) {
            //   return context.chart.data.labels[context.dataIndex];
            // },
          }
        },
        legend: {
          display: false,
          labels: {
            backgroundColor: "transparent",
            align: "center",
            boxWidth: 0
          }
        },

        // Core options
        aspectRatio: 5 / 3,
        layout: {
          padding: {
            top: 30,
            right: 30
          }
        },
        elements: {
          line: {
            fill: false
          }
        },
        scales: {
          xAxes: [
            {
              display: true,
              offset: true
            }
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      }
    };
  },

  methods: {
    handleGetData(query) {
      this.loaded = false;
      IndexData({ reqName: "/dashboard/location-statistics", query }).then(
        res => {
          const { data } = res.data;
          this.chartData.datasets[0].backgroundColor = "blue";
          this.chartData.datasets[0].data = data.map(el => el.campers_total);
          this.chartData.labels = data.map(el => {
            return el.location;
          });
          this.loaded = true;
        }
      );
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        this.handleGetData(query);
      },
      immediate: true
    }
  }
};
</script>
